import { withUrl, get } from '../rest';


const systemPart = withUrl('system');

export const system = {
    info: get<void, string>(
        () => systemPart({
            path: 'info',
        }),
    ),
};
